import { render, staticRenderFns } from "./cadordensproducao.vue?vue&type=template&id=610a3ef0&"
import script from "./cadordensproducao.vue?vue&type=script&lang=js&"
export * from "./cadordensproducao.vue?vue&type=script&lang=js&"
import style0 from "./cadordensproducao.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports